import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DatePicker } from 'antd';
import { getDataIntroduccioAsMoment, getUsuari } from '../../reducers';
import { omplirDataIntroduccio } from '../../actions';
import { esDiaFutur, esAnteriorDesdeDataActual } from '../../utils/dates';
import { isObservadorAdmin } from '../../utils/usuariRols';
import { MASCARA_DDMMYYYY } from '../../utils/dates';
import { MAX_MONTH_LAST_OBSERVATION } from '../../constantsObservacions';
import styles from './IntroduccioData.module.css';

class IntroduccioData extends Component {
	handleOnChange = (data) => {
		if (data) {
			this.props.omplirDataIntroduccio(data);
			this.props.onChange();
		}
	};

	esDataDeshabilitada = (data) => {
		const usuari = this.props.usuari;
		const isAdmin = isObservadorAdmin(usuari);
		return esDiaFutur(data) ? true : isAdmin ? false : esAnteriorDesdeDataActual(data, MAX_MONTH_LAST_OBSERVATION, 'months');
	};

	render() {
		const { dataSelecionada } = this.props;
		return (
			<div className={styles.introduccioData}>
				<label htmlFor='id-data'>Data de l'observació</label>
				<DatePicker value={dataSelecionada} onChange={this.handleOnChange} allowClear={false} format={MASCARA_DDMMYYYY} disabledDate={this.esDataDeshabilitada} id='id-data' />
			</div>
		);
	}
}

IntroduccioData.propTypes = {
	dataSelecionada: PropTypes.object.isRequired,
	omplirDataIntroduccio: PropTypes.func.isRequired,
	usuari: PropTypes.object
};

const mapStateToProps = (state) => {
	return {
		dataSelecionada: getDataIntroduccioAsMoment(state),
		usuari: getUsuari(state)
	};
};

export default connect(
	mapStateToProps,
	{ omplirDataIntroduccio }
)(IntroduccioData);
